// ignore-string-externalization
import { createPage } from "@apps/artists-spotify-com-c/src/lib/createPage";
import { accessRouteConfig } from "@apps/artists-spotify-com-c/src/app/routes/accessRouteConfig";
export default createPage(accessRouteConfig);
